import React, { useEffect } from 'react';
import { Button, List } from 'antd';
import { useQuery } from '../../../../../utils/hooks';
import { sendWidgetMessage } from '../../../../../utils/widgetUtils';
import SvgCheckCircle from '../../../assets/images/SvgCheckCircle';
import axios from 'axios';

function BookingAccountConfirmation({ useTrialConfirmation = false }) {
  const isInsideWidget = JSON.parse(useQuery().get('widget') || 'null');

  useEffect(() => {
    axios.post('webhooks/trigger_pending');
  }, []);

  return (
    <div className='pd-10 txt-center h-full'>
      <p className='fs-20 gSemiBold'>
        Great! Thanks for setting up your account 😁
      </p>

      {useTrialConfirmation ? (
        <>
          <p className='fs-20 gRegular mg-bottom-0'>
            Now it's time to download the app!
          </p>
          <p className='fs-30 mg-bottom-0'>⬇️</p>
        </>
      ) : (
        <>
          <List
            bordered={false}
            className='w-fit mg-auto-lr'
            size='small'
            dataSource={[
              'View Ticket Information',
              'Upload Catch Reports',
              'Favourite & Leave Reviews',
            ]}
            renderItem={(item) => (
              <List.Item
                className={
                  'gMedium fs-15 txt-left pd-top-5 pd-bottom-5 mg-bottom-10 display-flex-row gap-05r row-center justify-start'
                }
                style={{ borderBottom: 'none' }}
              >
                <SvgCheckCircle className='sb-blue-500 fs-18' /> {item}
              </List.Item>
            )}
          />
          <p className={'pd-top-8 gBold fs-15 mg-bottom-20'}>
            and much more...
          </p>

          <div className='gap-1r row-center'>
            <Button
              href={!isInsideWidget ? `/user/profile` : undefined}
              onClick={() => {
                if (isInsideWidget) {
                  sendWidgetMessage({ type: 'widgetCollapse' });
                }
              }}
              className='sb-blue-gradient-bg-right border-1 sb-blue-border-300 mg-top-10 white gSemiBold brFull fs-18 txt-center w-full max-w-300 pd-10 h-fit txt-wrap antd-link-button-override mg-auto-lr'
            >
              {!isInsideWidget ? 'View My SB Profile' : 'Close Booking Widget'}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default BookingAccountConfirmation;
